import { Component } from "@angular/core";
import { ModalController } from "@ionic/angular";

@Component({
  selector: "rc-scan-item-modal",
  templateUrl: "./scan-item-modal.component.html",
  styleUrls: ["./scan-item-modal.component.scss"],
  standalone: false,
})
export class ScanItemModalComponent {
  constructor(private readonly modalController: ModalController) {}

  public async handleQrCodeScanned(itemId: string): Promise<void> {
    await this.modalController.dismiss(itemId);
  }
}
